module.exports = __webpack_public_path__ + "img/logo-full.6e99fdb5.png";